module.exports = __webpack_public_path__ + "static/media/vijaya-publications-f-logo.a58f5028.png";